<template>
  <div class="contents">
    <section class="w-full bg-transparent" :class="[alert ? '' : loginMenuOpen || showSearchField ? 'absolute top-0 left-0 right-0 bottom-0 z-40' : 'relative', onMapPage ? 'hidden md:block' : 'block'].join(' ')">
      <div>
        <ellevio-web-mobile-nav-head
          :api-url="apiUrl"
          :top-names="topNames && Object.keys(topNames).length ? topNames : undefined"
          :logo-link="logoLink"
          :menu-open="false"
          :tree-open="false"
          :tree-heading="treeHeading"
          :tree-heading-link="treeHeadingLink"
          :show-search-field="showSearchField"
          :search="search"
          :my-pages="myPages"
          :show-login="showLogin"
          :login-menu="loginMenu"
          :user-logged-in="userLoggedIn"
          :translations="translations"
          :show-autocomplete-list="showAutocompleteList"
          @show-search-field="handleShowSearchField"
          @close-search-field="handleCloseSearchField"
          @toggle-login-menu="handleToggleLoginMenu"
          @toggle-menu="handleToggleMenu"
          @close-menu="handleCloseMenu"
          @show-main-menu="handleShowMainMenu" />
        <ellevio-web-mobile-login-wide-area v-show="loginMenuOpen" :my-pages="myPages" :translations="translations" :login="loginMenu" :user-logged-in="userLoggedIn" @close-login-menu="closeLoginMenu" />
        <ellevio-web-mobile-search-wide-area
          v-show="showSearchField"
          :my-pages="myPages"
          :translations="translations"
          :searchApiUrl="searchApiUrl"
          :searchPageUrl="searchPageUrl"
          :searchNoHitsContent="searchNoHitsContent"
          @close-search-field="handleCloseSearchField"
          @close-search-menu="handleCloseSearchField" />
      </div>
    </section>
    <section v-show="menuOpen" class="absolute top-0 left-0 right-0 z-[2000] block w-full min-h-screen back lg:hidden bg-[rgba(44,40,39,0.4)] mobile-area" @click="closeMenuFromSide">
      <div class="block absolute top-0 right-0 z-50 w-full min-h-screen bg-white lg:hidden mobile-main">
        <nav class="relative overflow-y-scroll h-[100dvh]">
          <div class="flex flex-col items-end py-2.5 pr-0 pl-2 bg-white lg:p-2 border-b-gray-ultralight border-b-1">
            <button
              class="flex flex-col items-center justify-center pt-1 mr-2.5 focus:outline-black-alt focus:!-outline-offset-2"
              type="button"
              @click="handleToggleMenu"
              @keyup.enter="handleToggleMenu"
              @keydown.esc="closeMenu"
              data-testid="mobileMenuCloseButton">
              <img v-show="menuOpen" width="18" height="18" aria-hidden="true" class="inline top-mobile-icons" src="../../../assets/images/cross-black.svg" alt="close menu" />
              <span class="whitespace-nowrap mt-0.5 leading-4 uppercase font-futuraEfDemiBold text-[0.6875rem] text-newColors-gray-content">{{ translations?.topMenuMobile.closeMenu }}</span>
            </button>
          </div>
          <ellevio-web-mobile-nav-tree :menuItems="menuItems" :menuOpen="menuOpen" :translations="translations" />
          <ellevio-web-mobile-nav-footer :footerLinks="footerLinks" :footer-language="otherLanguage" :translations="translations" />
        </nav>
      </div>
    </section>
  </div>
</template>

<script>
import EllevioWebMobileNavHead from './MobileNavHead.vue'
import EllevioWebMobileLoginWideArea from './MobileLoginWideArea.vue'
import EllevioWebMobileSearchWideArea from './MobileSearchWideArea.vue'
import EllevioWebMobileNavTree from './MobileNavTree.vue'
import EllevioWebMobileNavFooter from './MobileNavFooter.vue'

import apiUrl from '../../../helpers/apiUrl'
import axios from 'axios'
import { useEllevioStore } from '../../../store'
import { mapActions } from 'pinia'

export default {
  name: 'EllevioWebMobileNav',
  components: {
    EllevioWebMobileNavHead,
    EllevioWebMobileLoginWideArea,
    EllevioWebMobileSearchWideArea,
    EllevioWebMobileNavTree,
    EllevioWebMobileNavFooter
  },
  props: {
    mobileNavigationData: {
      type: Object,
      default: () => {}
    },
    translations: {
      type: Object,
      default: () => {}
    },
    loginMenu: {
      type: Object,
      default: () => {}
    },
    onMapPage: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String,
      default: 'sv'
    },
    alert: {
      type: Boolean,
      default: false
    },
    topNames: {
      type: Object,
      default: () => {}
    },
    logoLink: {
      type: String,
      default: '/'
    },
    myPages: {
      type: Boolean,
      default: false
    },
    tree: {
      type: Object,
      default: () => {}
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    topLinks: {
      type: Array
    },
    breakpoint: {
      type: String,
      default: '64rem'
    },
    //"startsidans" länklista
    initialLinks: {
      type: Array
    },
    search: {
      type: Object,
      default: () => {}
    },
    footerLinks: {
      type: Array
    },
    otherLanguage: {
      type: Object
    },
    apiUrl: {
      type: String,
      required: true
    },
    showAutocompleteList: {
      type: Boolean,
      default: false
    },
    userLoggedIn: {
      type: Boolean,
      default: false
    },
    searchApiUrl: {
      type: String,
      default: ''
    },
    searchPageUrl: {
      type: String,
      default: ''
    },
    searchNoHitsContent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menuOpen: false,
      loginMenuOpen: false,
      showNavigationTree: false,
      showSearchField: false,
      fetchedData: [],
      treeData: {},
      treeHeading: '',
      treeHeadingLink: '',
      isMobile: true
    }
  },
  computed: {
    matchMediaQuery() {
      return window.matchMedia(` (min-width: ${this.breakpoint}) `)
    },
    showLogin() {
      return this.loginMenu !== undefined && this.loginMenu !== null && Object.keys(this.loginMenu).length > 0
    }
  },
  mounted() {
    this.isMobile = this.matchMediaQuery ? !this.matchMediaQuery.matches : true
    this._boundedResize = this.resize.bind(this)
    window.addEventListener('resize', this._boundedResize)

    if (this.tree && Object.keys(this.tree).length > 0) {
      this.treeData = this.tree
      this.treeHeading = this.treeData.text
      this.treeHeadingLink = this.treeData.url
      this.showNavigationTree = true
    }
  },
  unmounted() {
    window.removeEventListener('resize', this._boundedResize)
  },
  methods: {
    ...mapActions(useEllevioStore, ['closeDeliverySiteSelectorMobile']),
    resize: function () {
      this.isMobile = this.matchMediaQuery ? !this.matchMediaQuery.matches : true

      if (!this.isMobile && this.menuOpen) {
        this.handleToggleMenu()
      }
    },
    handleFixedScrollState(toggle) {
      const bodyClassNames = ['fixed', 'overflow-y-scroll', 'w-full']
      if (!toggle && document.body.classList.contains(bodyClassNames[0])) {
        document.body.classList.remove(...bodyClassNames)
      } else {
        document.body.classList.add(...bodyClassNames)
      }
    },
    handleToggleMenu() {
      this.menuOpen = !this.menuOpen

      this.handleFixedScrollState(this.menuOpen)

      //also close login menu
      this.loginMenuOpen = false

      //also close facility selector from MyPages
      this.closeDeliverySiteSelectorMobile()
    },
    closeMenuFromSide(e) {
      if (this.menuOpen && typeof e.target.className === 'string' && e.target.className.indexOf('mobile-area') !== -1) {
        this.menuOpen = !this.menuOpen
        this.handleFixedScrollState(this.menuOpen)
      }
    },
    handleToggleLoginMenu() {
      this.loginMenuOpen = !this.loginMenuOpen

      this.handleFixedScrollState(this.loginMenuOpen)

      //also close deliverySite selector from MyPages
      this.closeDeliverySiteSelectorMobile()
    },
    closeLoginMenu() {
      this.loginMenuOpen = false
      const bodyClassNames = ['fixed', 'overflow-y-scroll', 'w-full']
      if (document.body.classList.contains(bodyClassNames[0])) {
        document.body.classList.remove(...bodyClassNames)
      }
    },
    handleShowSearchField() {
      this.showSearchField = true

      const bodyClassNames = ['fixed', 'overflow-y-scroll', 'w-full']
      if (!document.body.classList.contains(bodyClassNames[0])) {
        document.body.classList.add(...bodyClassNames)
      }
    },
    handleCloseSearchField() {
      this.showSearchField = false
      const bodyClassNames = ['fixed', 'overflow-y-scroll', 'w-full']
      if (document.body.classList.contains(bodyClassNames[0])) {
        document.body.classList.remove(...bodyClassNames)
      }
    },
    handleCloseMenu() {
      if (this.menuOpen) {
        this.menuOpen = !this.menuOpen
      }
    },
    handleShowMainMenu() {
      this.treeData = {}
      this.showNavigationTree = false
    },
    handleShowNavigationTree: async function (parentId) {
      if (!this.showNavigationTree) {
        this.treeData = await this.fetchChildren(parentId)

        this.treeHeading = this.treeData.text
        this.treeHeadingLink = this.treeData.url
        this.showNavigationTree = !this.showNavigationTree
      } else {
        this.showNavigationTree = !this.showNavigationTree
      }
    },
    fetchChildren: async function (parentId) {
      if (!this.fetchedData[parentId]) {
        const response = await axios.get(`${apiUrl.getMenuChildrenByParentId}${parentId}`, { headers: { 'Accept-Language': this.lang } })
        const responseData = response.data.data
        this.fetchedData[parentId] = responseData

        return responseData
      }

      return this.fetchedData[parentId]
    }
  }
}
</script>
